// @ts-check
import { NodeType } from '@contentstack/utils';
import classNames from 'classnames';
import React from 'react';
import config from '~/config';
import { ConstructCustomElement, ConstructFragmentOverride, GetCopyFromJson } from '~/contentstack/rendering';
import LinkButton from './LinkButton';

import './ProductCard.scss';

/**
 * @typedef ProductCardOption
 * @property {string} [onboard_product_param]
 * @property {import('../CSTypes').CSFile | null} [product_icon]
 * @property {import('../CSTypes').CSJRTE[]} product_information
 * @property {string} product_name
 * @property {string} [product_prefix]
 * @property {import('../CSTypes').CSJRTE[]} subheading
 * @property {'branch' | 'online'} which_button
 */
/** @type {import('~/types/React').ReactFC<{ option: ProductCardOption }>} */
const ProductCard = ({ option, ...rest }) => {
	const subHeading = GetCopyFromJson(option.subheading, ConstructFragmentOverride('p'));
	const productInfo = GetCopyFromJson(
		option.product_information,
		ConstructCustomElement(NodeType.LIST_ITEM, (node, next) => (
			<li>
				<span>{next(node.children)}</span>
			</li>
		))
	);

	const prodQuery = option?.onboard_product_param ? `?product=${option?.onboard_product_param}` : '';

	/** @type {import('./LinkButton').ButtonOptions} */
	const buttonOptions = {
		button_link: option.which_button === 'branch' ? '/locations/' : config.OnboardUrl + prodQuery,
		button_style: option.which_button === 'branch' ? 'tertiary' : 'primary',
		button_text: option.which_button === 'branch' ? 'Open in Branch' : 'Open an Account',
		open_in_new_tab: false,
		button_features: ['full'],
	};

	return (
		<div {...rest} className={classNames('cs-product-card', rest.className)}>
			<header className="title-row">
				<span className="title-line">
					{option.product_prefix && <span className="ozk-prefix">{option.product_prefix}</span>}
					<span className="title">{option.product_name}</span>
				</span>
				<span className="sub-title">{subHeading}</span>
			</header>

			<div className="body">
				{/* Add the icon component if it exists */}
				{!!option?.product_icon?.url && <img className="right-icon" src={option.product_icon?.url} alt="" />}

				{productInfo}
			</div>

			<div className="btn-container">
				<LinkButton className="card-btn card-btn--open-now" options={buttonOptions} />
			</div>
		</div>
	);
};

export default ProductCard;
